/** Five feature rows, each anchored by a real product replica. */
import { AttendanceReplica, KioskReplica, PayrollReplica, ResourcesReplica, RotaReplica } from '@/components/landing/ProductReplicas';

const FEATURES = [
  {
    id: 'rotas',
    title: 'Staff Rotas',
    text: 'Create and manage weekly schedules quickly. Draft the week, assign shifts and publish so everyone sees the same rota — no more screenshots in group chats.',
    Replica: RotaReplica,
  },
  {
    id: 'kiosk',
    title: 'Clock In & Out',
    text: 'Employees clock in and out using the RotaHQ kiosk on any tablet or phone, with a personal PIN and location controls where appropriate.',
    Replica: KioskReplica,
  },
  {
    id: 'attendance',
    title: 'Attendance Tracking',
    text: 'Review worked hours against the schedule and spot unusual sessions — late starts, missed clock-outs and no-shows are flagged for you to review.',
    Replica: AttendanceReplica,
  },
  {
    id: 'payroll',
    title: 'Payroll',
    text: 'Review and finalise employee hours before payroll. Worked hours flow straight from attendance into payslip drafts, with overtime, tax and NI estimates.',
    Replica: PayrollReplica,
  },
  {
    id: 'resources',
    title: 'Resources',
    text: 'Keep announcements, health & safety procedures, emergency procedures and restaurant rules in one place your whole team can access.',
    Replica: ResourcesReplica,
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="bg-[color:var(--brand-bg-2)] border-y border-[color:var(--brand-border)] scroll-mt-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <h2 className="text-3xl sm:text-4xl font-display font-semibold tracking-tight max-w-2xl" data-testid="marketing-features-heading">
          Everything you need to manage your restaurant team.
        </h2>
        <div className="mt-10 space-y-10 sm:space-y-14">
          {FEATURES.map((feature, i) => (
            <div
              key={feature.id}
              className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center [content-visibility:auto]"
              data-testid={`marketing-feature-${feature.id}`}
            >
              <div className={i % 2 === 1 ? 'lg:order-2' : ''}>
                <h3 className="text-xl sm:text-2xl font-display font-semibold">{feature.title}</h3>
                <p className="mt-2.5 text-sm sm:text-base text-[color:var(--brand-text-muted)] leading-relaxed max-w-lg">{feature.text}</p>
              </div>
              <div className={i % 2 === 1 ? 'lg:order-1' : ''}>
                <feature.Replica />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
